import { StorefrontProductDocumentsSection } from '@emporion/ui'
import type { CatalogProductDocument } from '../../types'

type Props = {
  documents: CatalogProductDocument[]
}

const ProductDocumentsSection = ({ documents }: Props) => (
  <StorefrontProductDocumentsSection documents={documents} />
)

export default ProductDocumentsSection
